import $ from 'jquery';
//import { spring } from "motion"
import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/effect-fade';

window.$ = $;
window.Swiper = Swiper;

$('.clickable').click(function(e){
    let $this = $(this);

    // Check if click was on the actual clickable element or its children
    let $target = $(e.target).closest('.clickable');
    if ($target.length && $target.find("a").length) {
        let $link = $target.find("a:first");
        if ($link.attr("target") === "_blank") {
            window.open($link.attr("href"), "_blank");
        } else {
            window.location.href = $link.attr("href");
        }
    }
});


function updateHeaderHeight() {
    const headerHeight = $('header').outerHeight();
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
}

// Initiales Setzen
$(document).ready(updateHeaderHeight);

// Bei Resize mit Throttle
let resizeTimeout;
$(window).on('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateHeaderHeight, 100);
});

document.querySelectorAll('[data-animate]').forEach(element => {
    const threshold = parseFloat(element.dataset.animateThreshold) || 0.5;
    const rootMargin = element.dataset.animateRootMargin || "0px";
    const delay = parseInt(element.dataset.animateDelay) || 0;
    const once = element.dataset.animateOnce !== 'false'; // Default true

    let timeoutId = null;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const el = entry.target;

            if (entry.isIntersecting) {
                // Sofort setzen
                el.classList.add('viewport-start');
                el.classList.remove('viewport-out');

                // Direkt in-view setzen basierend auf threshold
                if (entry.intersectionRatio >= threshold) {
                    el.classList.add('in-view');

                    // Nur bei once=true den Observer stoppen, NACHDEM in-view gesetzt wurde
                    if (once) {
                        observer.unobserve(el);
                    }
                }

                // Mit Delay nur für viewport-full
                if (delay > 0) {
                    timeoutId = setTimeout(() => {
                        if (entry.intersectionRatio >= 0.95) {
                            el.classList.add('viewport-full');
                        }
                    }, delay);
                } else {
                    if (entry.intersectionRatio >= 0.95) {
                        el.classList.add('viewport-full');
                    }
                }

            } else {
                // Pending setTimeout clearen
                if (timeoutId) {
                    clearTimeout(timeoutId);
                    timeoutId = null;
                }

                // Element verlässt Viewport (nur wenn once=false)
                if (!once) {
                    el.classList.add('viewport-out');
                    el.classList.remove('viewport-start', 'viewport-full', 'in-view');
                }
            }
        });
    }, {
        root: null,
        rootMargin: rootMargin,
        threshold: [0, threshold, 0.95]
    });

    observer.observe(element);

    // Mouse Events
    element.addEventListener('mouseenter', () => {
        element.classList.add('mouse-in');
        element.classList.remove('mouse-out');
    });

    element.addEventListener('mouseleave', () => {
        element.classList.add('mouse-out');
        element.classList.remove('mouse-in');
    });
});